export default __webpack_public_path__ + "static/media/030_corner_veryclose.7021ccf3.mp3";